<template>
  <div class="approval-history mt-4" :data-test="`history-${scope}`">
    <!-- TKP-156 / tunesoft2 s.4–6: "Tarihçe" — açılır/kapanır, varsayılan kapalı; tamamlanmış taslaklar; görüntüleme salt okunur -->
    <a href="javascript:;" class="d-flex align-items-center text-dark" data-test="history-toggle" @click="toggle">
      <i class="bx" :class="open ? 'bx-chevron-down' : 'bx-chevron-right'"></i>
      <i class="bx bx-history ml-1 mr-1"></i>
      <h4 class="mb-0" data-test="history-title">{{ $t("approval.history.title") }}</h4><!-- TKP-237 o.4 / m.1: başlık birkaç boy büyük -->
    </a>
    <div v-if="open" class="mt-2">
      <div v-if="loading" class="text-muted small">{{ $t("common.loading") }}</div>
      <div v-else-if="!docs.length" class="text-muted small" data-test="history-empty">{{ $t("approval.history.empty") }}</div>
      <table v-else class="table table-sm" data-test="history-table">
        <thead>
          <tr>
            <th>{{ $t("approval.history.name") }}</th>
            <th>{{ $t("approval.history.submitted-by") }}</th>
            <th>{{ $t("approval.history.submitted-at") }}</th>
            <th>{{ $t("approval.history.completed-at") }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="pkg in docs" :key="pkg._id" data-test="history-row">
            <td>{{ pkg.name || $t("approval.department") }}</td>
            <td>{{ pkg.authorName || "—" }}</td>
            <td><small>{{ pkg.submittedAt | date(true) }}</small></td>
            <td><small>{{ pkg.completedAt | date(true) }}</small></td>
            <td class="text-right"><a href="javascript:;" data-test="history-view" v-b-tooltip.hover :title="$t('approval.history.view')" @click="view(pkg)"><i class="bx bx-search-alt"></i></a></td>
          </tr>
        </tbody>
      </table>
      <b-pagination v-if="totalDocs > limit" v-model="page" :total-rows="totalDocs" :per-page="limit" size="sm" @change="load" />
    </div>

    <!-- salt okunur içerik: düzenleme / silme kapalı -->
    <b-modal v-model="detail.show" size="xl" :title="detail.pkg ? detail.pkg.name || $t('approval.history.title') : ''" hide-footer data-test="history-detail">
      <div v-if="detail.pkg" class="small text-muted mb-2">
        {{ $t("approval.history.submitted-by") }}: {{ detail.pkg.authorName || "—" }} · {{ $t("approval.history.submitted-at") }}: {{ detail.pkg.submittedAt | date(true) }} · {{ $t("approval.history.completed-at") }}: {{ detail.pkg.completedAt | date(true) }}
      </div>
      <draft-rows-table v-if="detail.pkg" :edits="detail.pkg.edits || []" readonly />
    </b-modal>
  </div>
</template>

<script>
import DraftRowsTable from "./draft-rows-table";

export default {
  name: "approval-history",
  components: { DraftRowsTable },
  props: { scope: { type: String, default: "mine" } }, // mine: gönderdiklerim; decided: onayladıklarım
  data() {
    return { open: false, loading: false, docs: [], totalDocs: 0, page: 1, limit: 20, detail: { show: false, pkg: null } };
  },
  methods: {
    async toggle() {
      this.open = !this.open;
      if (this.open && !this.docs.length) await this.load(1);
    },
    async load(page = this.page) {
      this.loading = true;
      try {
        const { data } = await this.$store.dispatch("approval/history", { scope: this.scope, page, limit: this.limit });
        this.docs = (data && data.docs) || [];
        this.totalDocs = (data && data.totalDocs) || 0;
        this.page = page;
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.loading = false;
      }
    },
    async view(pkg) {
      try {
        const { data } = await this.$store.dispatch("approval/packageDetail", pkg._id);
        this.detail = { show: true, pkg: data };
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
